import Manager from 'coreClasses/Manager';
import IdentityProvidersFactory from './IdentityProvidersFactory';
import IdentityProvider from './providers/IdentityProvider';

/**
 * Represents IdentityProvidersMgr
 */
export class IdentityProvidersMgr extends Manager {

	/**
	 * Returns the identity provider configuration
	 * @param {string} providerName - provider name
	 * @returns {object} identity provider sitePreference
	 */
	initConfig(providerName: string) {
		return this.managerRepository.getConfigurationsMgr().get(
			`sitePreferences.${providerName.toLowerCase()}IdentityProvider`
		);
	}

	/**
	 * Returns the provider object based on the type requested
	 * @param {string} providerName - provider name
	 * @returns {Promise<IdentityProvider>|null} identity provider instance
	 */
	async getProvider(providerName: string): Promise<IdentityProvider> {
		return await IdentityProvidersFactory.create(providerName, this.initConfig(providerName));
	}
}

export default IdentityProvidersMgr;
